"use client";
import { createPlayer } from "../../player/create-player.js";
import { liveAudioFeatures } from "@videojs/core/dom";
//#region src/presets/live-audio/player.ts
/** Preconfigured player with the live audio features. */
const { Player: LiveAudioPlayer, usePlayer } = createPlayer({
	features: liveAudioFeatures,
	displayName: "LiveAudioPlayer"
});
//#endregion
export { LiveAudioPlayer, usePlayer };

//# sourceMappingURL=player.js.map